var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66667 6.08333C7.66667 4.53624 8.28125 3.05251 9.37521 1.95854C10.4692 0.864581 11.9529 0.25 13.5 0.25C15.0471 0.25 16.5308 0.864581 17.6248 1.95854C18.7188 3.05251 19.3333 4.53624 19.3333 6.08333C19.3333 7.63043 18.7188 9.11416 17.6248 10.2081C16.5308 11.3021 15.0471 11.9167 13.5 11.9167C11.9529 11.9167 10.4692 11.3021 9.37521 10.2081C8.28125 9.11416 7.66667 7.63043 7.66667 6.08333ZM7.66667 14.8333C5.7328 14.8333 3.87813 15.6016 2.51068 16.969C1.14323 18.3365 0.375 20.1911 0.375 22.125C0.375 23.2853 0.835936 24.3981 1.65641 25.2186C2.47688 26.0391 3.58968 26.5 4.75 26.5H22.25C23.4103 26.5 24.5231 26.0391 25.3436 25.2186C26.1641 24.3981 26.625 23.2853 26.625 22.125C26.625 20.1911 25.8568 18.3365 24.4893 16.969C23.1219 15.6016 21.2672 14.8333 19.3333 14.8333H7.66667Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.bd71fcee240208e10409519137871977.svg";
export { ForwardRef as ReactComponent };